export const CATALOG_CATEGORIES = [
  { id: "figuras", label: "Figuras de acción", img: "/catalogo/figuras.webp", blurb: "De la primera ola de 1988 a las súper articuladas de hoy." },
  { id: "comics", label: "Cómics", img: "/catalogo/comics.webp", blurb: "Mirage, Archie, IDW y las ediciones mexicanas." },
  { id: "vehiculos", label: "Vehículos y playsets", img: "/catalogo/vehiculos.webp", blurb: "Camionetas, alcantarillas y fortalezas móviles." },
  { id: "videojuegos", label: "Videojuegos", img: "/catalogo/videojuegos.webp", blurb: "Arcades, cartuchos y consolas." },
  { id: "ropa", label: "Ropa y accesorios", img: "/catalogo/ropa.webp", blurb: "Playeras, gorras, disfraces y más." },
  { id: "coleccionables", label: "Estatuas y coleccionables", img: "/catalogo/coleccionables.webp", blurb: "Piezas de exhibición y ediciones limitadas." },
];

export const categoryMeta = (id) => CATALOG_CATEGORIES.find((c) => c.id === id) ?? CATALOG_CATEGORIES[0];

export const COLLECTION_CATEGORIES = [
  ["juguetes", "Juguetes"], ["comics", "Cómics"], ["cds", "CDs"], ["dvds", "DVDs"], ["vhs", "VHS"], ["ropa", "Ropa y accesorios"],
  ["calzado", "Calzado"], ["dibujos", "Dibujos"], ["libros", "Libros y revistas"], ["papeleria", "Papelería"],
  ["mochilas", "Mochilas"], ["gorras", "Gorras"], ["posters", "Pósters"], ["tarjetas", "Tarjetas"],
  ["viajando", "Viajando"], ["coleccion", "De colección"], ["manualidades", "Manualidades"],
];

export const UNIVERSES = ["Clásicas (1980s)", "TMNT 1990", "TMNT 1998", "TMNT 2003", "TMNT 2007", "TMNT 2012", "TMNT 2014", "TMNT 2016", "TMNT 2018", "TMNT 2023"];

export const collectionLabel = (id) => COLLECTION_CATEGORIES.find(([k]) => k === id)?.[1] ?? id;
